/**
 * @generated SignedSource<<e692a6dcfb5936b11c6437300cd32ff1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "webhookService",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "step5WebhookServiceQuery",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "step5WebhookServiceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "549812d297d156b0d343516d16c27d5e",
    "id": null,
    "metadata": {},
    "name": "step5WebhookServiceQuery",
    "operationKind": "mutation",
    "text": "mutation step5WebhookServiceQuery(\n  $request: WebhookServiceRequestInput\n) {\n  webhookService(request: $request) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "efb3c124d70e097b530581c70268e9ea";

module.exports = node;
